import {
  GetFileUploadUrlCommand,
  GetFileUploadUrlCommandOutput,
  GetFileUploadUrlCommandInput,
} from "@amzn/ttechclaimintakeservice-client";

import { getAuthenticatedClient } from "../setup/getAuthenticatedClient";
import { MetricsPublisher } from "../../metrics/metrics";

export async function GetFileUploadUrlService(
  input: GetFileUploadUrlCommandInput
) {
  const { client } = await getAuthenticatedClient();
  if (!client) {
    return Promise.reject(new Error("Unauthorized"));
  }
  const command = new GetFileUploadUrlCommand(input);
  const metricsPublisher = new MetricsPublisher("api.GetFileUploadUrl");

  return await client
    .send(command)
    .then((response: GetFileUploadUrlCommandOutput) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderSuccessMetrics();
      return response;
    })
    .catch((error: any) => {
      metricsPublisher.publishAuthenticationLatencyMetrics();
      metricsPublisher.publishRenderFatalMetrics();
      throw error;
    });
}
